/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Menu from "@material-ui/core/Menu";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { Box, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { QRCodeSVG } from "qrcode.react";

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: "#778899",
        color: "white",
        padding: "2px",
        margin: "5px",
        marginTop: "9px",
        textAlign: "center",
        font: '12pt "Futura"',
        boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2)",
    },
    business_logo: {
        marginTop: "9px",
        backgroundColor: "white",
        height: "14mm",
        objectFit: "contain",
    },
    context_menu_button: {
        padding: "0px",
        marginTop: "-3px",
        marginBottom: "-3px",
        color: "white",
    },
    svg_layout: {
        height: "70mm",
        objectFit: "contain",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 50%",
        transformOrigin: "50% 50%",
        transition: "all .2s ease-in-out",
    },
    svg_layout2: {
        height: "130mm",
        objectFit: "contain",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 50%",
        transformOrigin: "50% 50%",
        transition: "all .2s ease-in-out",
    },
    business_name: {
        marginTop: "9px",
        width: "100%",
        font: '19pt "Futura"',
        fontWeight: "bolder",
        marginBottom: "5px",
    },
    business_details: {
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        display: "flex",
        flex: 1,
        backgroundColor: "#f1f1f1",
        transition: "background-color 0.3s ease",
        borderRadius: "7px",
        cursor: "pointer",
    },
    flex: {
        display: "flex",
    },
    flex_row: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
    },
    row_header: {
        paddingLeft: "20px",
        whiteSpace: "nowrap",
        flex: "1",
    },
    pricing_input: {
        backgroundColor: "transparent",
        border: "1px dotted #cecece",
        borderRadius: "0",
        outline: "none",
        width: "80px",
        padding: "0",
        boxSizing: "content-box",
        transition: "all 0.3s",
        textAlign: "right",
        boxShadow: "none !important",
        lineHeight: "normal",
        height: "1rem",
        fontSize: "10pt",
        marginRight: "10px",
    },
    not_editable: {
        border: "none",
        color: "darkgrey",
    },
    pricing_SUBTOTAL: {
        color: "white",
        fontSize: "12pt",
        width: "80px",
        fontWeight: "600",
        border: "none",
    },
    pricing_TOTAL: {
        color: "white",
        fontSize: "14pt",
        width: "100px",
        marginTop: "2px",
        border: "none",
    },
    extra_item_text: {
        border: "none",
        outline: "none",
        padding: "0",
        boxSizing: "content-box",
        transition: "all 0.3s",
        borderBottom: "none !important",
        boxShadow: "none !important",
        lineHeight: "normal",
        paddingRight: "20px",
        flex: "1",
        font: '8pt "Futura"',
        fontWeight: "normal",
    },
    pay_input: {
        border: "none",
        outline: "none",
        padding: "0",
        boxSizing: "content-box",
        transition: "all 0.3s",
        borderBottom: "none !important",
        boxShadow: "none !important",
        lineHeight: "normal",
        flex: "1",
        font: '8pt "Futura"',
        fontWeight: "normal",
        textAlign: "center",
        width: "60px",
    },
    pay_section: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    pay_header: {
        font: '8pt "Futura"',
        fontWeight: "bolder",
        padding: "0px",
        textAlign: "center",
    },
    acceptance: {
        fontSize: "10pt",
        padding: "0px 10px",
        fontWeight: "500",
    },
    sign: {
        height: "60px",
        background: "#f0f0f0",
    },
    layout: {
        width: "100%",
        height: "70mm",
        minHeight: "70mm",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 50%",
        transition: "all .2s ease-in-out",
        zIndex: "-99",
    },
    threedlayout: {
        width: "100%",
        backgroundImage: "url(localhost/)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 50%",
        border: "1px dotted #CCCCCC",
        height: "40mm",
    },
    linky: {
        color: "blue",
        "&:hover": {
            color: "#8080ff",
            textDecoration: "underline",
            cursor: "pointer",
        },
    },
    pricing_notes: {
        fontSize: "0.6rem",
        textAlign: "right",
        marginBottom: "4px",
    },
    colour_panel: {
        fontSize: "0.8rem",
        padding: "3px",
        margin: "1px",
        textAlign: "center",
        borderRadius: "3px",
        fontWeight: "600",
    },
    notes: {
        border: "1px dotted darkgrey",
        padding: "0px 10px",
        flex: "1",
        font: '9pt "Open Sans"',
        resize: "none",
        width: "100%",
        boxSizing: "border-box",
        maxWidth: "100%",
        maxHeight: "100%",
        overflow: "hidden",
    },
    notes_display: {
        border: "none",
        margin: "10px",
        flex: "1",
        font: '9pt "Open Sans"',
        whiteSpace: "pre-wrap",
    },
    qrContainer: {
        display: "flex",
        paddingTop: "5px",
        alignItems: "center",
        justifyContent: "space-around",
    },
    qrSVG: {
        flexShrink: "0",
    },
    qrURL: {
        width: "160px",
        wordWrap: "break-word",
    },
}));

const headerStyles = makeStyles((theme) => ({
    header: {
        color: "white",
        backgroundColor: "white",
        display: "flex",
        font: '12pt "Futura"',
        zIndex: "10",
    },
    header_logo: {
        flex: "4",
        textAlign: "center",
        backgroundColor: "white",
        padding: "0px 0px 0px 10px",
    },
    logo: {
        height: "14mm",
    },
    header_left: {
        fontSize: "16pt",
        fontWeight: "bolder",
        padding: "20px 20px 10px 10px",
        flex: "16",
        lineHeight: "1.1rem",
    },
    quote_number: {
        fontSize: "12pt",
    },
    header_right: {
        fontSize: "8pt",
        textAlign: "right",
        padding: "5px 4px 0px 0px",
        flex: "6",
    },
    section_header: {
        backgroundColor: "#778899",
        color: "white",
        padding: "0px",
        margin: "0px",
        marginBottom: "5px",
        textAlign: "center",
        font: '12pt "Futura"',
    },
}));

function Header(props) {
    const classes = headerStyles();
    const { manufacturer, title } = props;

    return (
        <>
            <div className={classes.header + " z_depth_1x"} style={{ backgroundColor: manufacturer.BrandColour }}>
                <div className={classes.header_left}>
                    <span id="title">{title}</span>
                </div>
                {props.DatePickerComponent && (
                    <div style={{ backgroundColor: "white" }}>{props.DatePickerComponent}</div>
                )}

                <div className={classes.header_logo}>
                    <img className={classes.logo} src={manufacturer.Logo} />
                </div>
            </div>
        </>
    );
}

const footerStyles = makeStyles((theme) => ({
    text_and_label_item: {
        lineHeight: "1.0rem",
        marginLeft: "5px",
        marginRight: "5px",
    },
    section_row: {
        marginTop: "5px",
        display: "flex",
        flex: "0 0",
    },
    footer_text: {
        color: "grey",
        textAlign: "start",
        font: '10pt "Futura"',
    },
    footer_page_numbers: {
        color: "grey",
        textAlign: "end",
        font: '10pt "Futura"',
    },
}));

export function Footer(props) {
    const classes = footerStyles();
    const { footer_text, page_number } = props;

    return (
        <>
            <div className={classes.section_row + " footer"}>
                {" "}
                <div className={classes.text_and_label_item} style={{ flex: "20" }}>
                    <div className={classes.footer_text}>{footer_text}</div>
                </div>
                <div className={classes.text_and_label_item} style={{ flex: "3" }}>
                    <div className={classes.footer_page_numbers}>Page {page_number}</div>
                </div>
            </div>
        </>
    );
}

const API_BASE = (brandRedirect = "", manufacturer = "") => {
    if (window.location.href.includes("GamaReport")) {
        // Report-Generator
        if (brandRedirect.includes("localhost")) {
            return "http://localhost:62027/api/";
        } else if (brandRedirect.includes("test")) {
            return manufacturer === "Lysaght"
                ? "https://test.lysaghtlivingdesigner.lysaght.com/api/"
                : "https://test.centenarydesignsuite.fielders.com.au/api/";
        } else if (brandRedirect.includes("preprod")) {
            return manufacturer === "Lysaght"
                ? "https://preprod.lysaghtlivingdesigner.lysaght.com/api/"
                : "https://preprod.centenarydesignsuite.fielders.com.au/api/";
        } else {
            return manufacturer === "Lysaght"
                ? "https://lysaghtlivingdesigner.lysaght.com/api/"
                : "https://centenarydesignsuite.fielders.com.au/api/";
        }
    } else {
        // Design-Cloud
        if (window.location.href.includes("localhost")) window.debug = true;
        return window.debug ? "http://localhost:62027/api/" : "/api/";
    }
};

const CustomTextField = withStyles({
    root: {
        flex: 1,
        marginRight: "5px",
        marginLeft: "5px",
        font: '8pt "Futura"',
        "& label": {
            fontSize: "0.8rem",
            color: "#778899",
        },
        "& .MuiInput-formControl": {
            font: '11pt "Futura"',
            fontWeight: "600",
            marginTop: "8px",
        },
        "& label.Mui-focused": {
            color: "#778899",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#778899",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "red",
            },
            "&:hover fieldset": {
                borderColor: "yellow",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#778899",
            },
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#778899",
        },
        "& .MuiFormLabel-root.Mui-disabled": {
            color: "#778899",
        },
        "& .MuiInput-underline.Mui-disabled:before": {
            borderBottomStyle: "solid",
        },
    },
})(TextField);

export default function QuotePage(props) {
    const { manufacturer, job, print, GetHTMLColour, user, footer_text, page_number, brandRedirect } = props;
    const pricingParameters = job.QuoteParameters?.PRICING_PARAMETERS;
    const documentParameters = job.QuoteParameters?.DOCUMENTS;
    const rotate = documentParameters?.rotate;
    const defaultJobNotes = job?.Distributor?.DefaultQuoteNotes || "";
    const customer_type = job?.Customer?.Type;
    const displayOnlyPrice = job.QuoteParameters?.BOM?.SystemList?.display_only_total_price || 0;
    const displayOnlyDiscount = job.QuoteParameters?.BOM?.SystemList?.display_only_total_discount || 0;
    const markupStructure = job?.Distributor?.MarkupStructure?.Markups?.[customer_type];
    const PRICE_ERROR_SUMMARY = job.QuoteParameters?.BOM?.SystemList?.price_error_summary;
    const MATERIAL_PROMOTION_DISCOUNT = pricingParameters?.Promotion?.Discount || 0;
    const MATERIAL_KIT_PRICE_FROM_EPRICING =
        job.QuoteParameters?.BOM?.OrderList?.total_eprice || job.QuoteParameters?.BOM?.SystemList?.total_eprice;

    const [notes, setNotes] = useState(pricingParameters?.Notes ?? defaultJobNotes);
    const [pricingSummary, setPricingSummary] = useState([]);
    const [enterValue, setEnterValue] = useState(null);
    const [loadingAR, setLoadingAR] = useState(true);
    const [open, setOpen] = useState(false);
    const [buisnessDetails, setBuisnessDetails] = useState({
        name: job?.User?.DisplayName ?? "",
        address: job?.Distributor?.Address?.FormattedAddress?.replace(", Australia", "") ?? "",
        abn: job?.Distributor?.ABN ?? "",
        email: job?.Distributor?.Email ?? "",
        phone: job?.Distributor?.Phone ?? "",
        licence: job?.Distributor?.BuildingLicence ?? "",
    });

    let markup_structure = job?.Distributor?.MarkupStructure?.Markups?.[customer_type];

    const notesAreaRef = useRef(null);
    const initialRender = useRef(true);

    const handleSetEnter = (event) => {
        setEnterValue(event.target.value);
        event.target.select();
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleNotesChange = (e) => {
        const textarea = notesAreaRef.current;
        const currentValue = e.target.value;

        textarea.value = currentValue;

        if (textarea.scrollHeight > textarea.clientHeight) {
            e.preventDefault();
            return;
        }

        setNotes(currentValue);
    };

    const [values, setValues] = useState({
        material: print ? pricingParameters?.MaterialFixedPrice ?? 0 : "",
        installation: pricingParameters?.InstallationFixedPrice || 0,
        subtotal: displayOnlyPrice || MATERIAL_KIT_PRICE_FROM_EPRICING,
        discount_percentage: pricingParameters?.OverallDiscountPercentage || "0%",
        discount: pricingParameters?.OverallDiscount || 0,
        promo_discount: MATERIAL_PROMOTION_DISCOUNT,
        extra: pricingParameters?.ExtraCostsFixedPrice || 0,
        packing_and_del: "",
        gst: "",
        total: "",
    });

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const [customerValues, setCustomerValues] = useState({
        FirstName: job.Customer.FirstName,
        LastName: job.Customer.LastName,
        Phone: job.Customer.Phone,
        Email: job.Customer.Email,
        JobName: job.Customer.JobName,
        DeliveryNotes: job.SiteParameters.DeliveryNotes,
    });
    const handleCustomerChange = (prop) => (event) => {
        setCustomerValues({ ...customerValues, [prop]: event.target.value });
    };

    const handleFocus = (event) => event.target.select();

    const [paymentValues, setPaymentValues] = useState({
        deposit_percent: "",
        deposit: "",
        pp1_percent: "",
        pp1: "",
        pp2_percent: "",
        pp2: "",
        pp3_percent: "",
        pp3: "",
        final_percent: "",
        final: "",
    });

    let payment_structure_default = job.QuoteParameters?.PRICING_PARAMETERS?.PaymentStructure;
    if (!payment_structure_default) payment_structure_default = job?.Distributor?.MarkupStructure?.PaymentStructure;

    const [payment_structure, setPaymentStructure] = useState(payment_structure_default);

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
            return;
        }

        setLoadingAR(false);
    }, [job?.App?.current_GLB]);

    useEffect(() => {
        if (print) {
            setValues({
                material: print ? pricingParameters?.MaterialFixedPrice ?? 0 : "",
                installation: pricingParameters?.InstallationFixedPrice || 0,
                subtotal: displayOnlyPrice || MATERIAL_KIT_PRICE_FROM_EPRICING,
                discount_percentage: pricingParameters?.OverallDiscountPercentage || "0%",
                discount: pricingParameters?.OverallDiscount || 0,
                promo_discount: MATERIAL_PROMOTION_DISCOUNT,
                extra: pricingParameters?.ExtraCostsFixedPrice || 0,
                packing_and_del: "",
                gst: "",
                total: "",
            });
            setCustomerValues({
                FirstName: job.Customer.FirstName,
                LastName: job.Customer.LastName,
                Phone: job.Customer.Phone,
                Email: job.Customer.Email,
                JobName: job.Customer.JobName,
                DeliveryNotes: job.SiteParameters.DeliveryNotes,
            });
            setPaymentStructure(payment_structure_default);
            setPricingSummary([]);
        }
    }, [job]);

    useEffect(() => {
        if (MATERIAL_KIT_PRICE_FROM_EPRICING == null) return;

        setValues((prev) => ({
            ...prev,
            material: MATERIAL_KIT_PRICE_FROM_EPRICING * (1 + Number(markupStructure["Material"]) / 100),
        }));
    }, [MATERIAL_KIT_PRICE_FROM_EPRICING]);

    useEffect(() => {
        // as soon as `values.material` changes, recalc
        calculatePrices();
    }, [values.material]);

    const updatePP = (param, value, totalIncGST = null) => {
        if (!totalIncGST) totalIncGST = toNumber(values.total);
        let new_payment_structure = { ...payment_structure };
        if (print) new_payment_structure = { ...payment_structure_default };

        if (!print && param) {
            new_payment_structure[param] = value;

            if (param === "installation" && toNumber(values.installation) <= 0) {
                new_payment_structure.Deposit = job?.Distributor?.MarkupStructure?.PaymentStructure?.SupplyOnlyDeposit
                    ? job?.Distributor?.MarkupStructure?.PaymentStructure?.SupplyOnlyDeposit
                    : payment_structure_default.SupplyOnlyDeposit;
                new_payment_structure.Progress1 = 0;
                new_payment_structure.Progress2 = 0;
                new_payment_structure.Progress3 = 0;
            } else if (param === "installation" && toNumber(values.installation) > 0) {
                let payment_structure_def = job?.Distributor?.MarkupStructure?.PaymentStructure;
                if (!payment_structure_def) payment_structure_def = payment_structure_default;
                new_payment_structure.Deposit = payment_structure_def?.Deposit || 0;
                new_payment_structure.Progress1 = payment_structure_def?.Progress1 || 0;
                new_payment_structure.Progress2 = payment_structure_def?.Progress2 || 0;
                new_payment_structure.Progress3 = payment_structure_def?.Progress3 || 0;
            }

            setPaymentStructure({ ...new_payment_structure });
            props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "PaymentStructure", new_payment_structure);
        }

        let new_values = { ...paymentValues };

        //get payment structure;
        let DEPOSIT = new_payment_structure.Deposit;
        let PROGRESS1 = new_payment_structure.Progress1;
        let PROGRESS2 = new_payment_structure.Progress2;
        let PROGRESS3 = new_payment_structure.Progress3;

        if (toNumber(DEPOSIT < 100) || (typeof DEPOSIT === "string" && DEPOSIT.includes("%"))) {
            new_values.deposit_percent = toNumber(DEPOSIT) + "%";
            new_values.deposit = toAUD((totalIncGST * toNumber(DEPOSIT)) / 100);
        } else {
            new_values.deposit_percent = "-";
            new_values.deposit = toAUD(DEPOSIT);
        }

        if (toNumber(PROGRESS1 < 100) || (typeof PROGRESS1 === "string" && PROGRESS1.includes("%"))) {
            new_values.pp1_percent = toNumber(PROGRESS1) + "%";
            new_values.pp1 = toAUD((totalIncGST * toNumber(PROGRESS1)) / 100);
        } else {
            new_values.pp1_percent = "-";
            new_values.pp1 = toAUD(PROGRESS1);
        }

        if (toNumber(PROGRESS2 < 100) || (typeof PROGRESS2 === "string" && PROGRESS2.includes("%"))) {
            new_values.pp2_percent = toNumber(PROGRESS2) + "%";
            new_values.pp2 = toAUD((totalIncGST * toNumber(PROGRESS2)) / 100);
        } else {
            new_values.pp2_percent = "-";
            new_values.pp2 = toAUD(PROGRESS2);
        }

        if (toNumber(PROGRESS3 < 100) || (typeof PROGRESS3 === "string" && PROGRESS3.includes("%"))) {
            new_values.pp3_percent = toNumber(PROGRESS3) + "%";
            new_values.pp3 = toAUD((totalIncGST * toNumber(PROGRESS3)) / 100);
        } else {
            new_values.pp3_percent = "-";
            new_values.pp3 = toAUD(PROGRESS3);
        }

        let FINAL_VALUE =
            totalIncGST -
            toNumber(new_values.pp3) -
            toNumber(new_values.pp2) -
            toNumber(new_values.pp1) -
            toNumber(new_values.deposit);
        new_values.final_percent = ((FINAL_VALUE / totalIncGST) * 100).toFixed(0) + "%";
        new_values.final = toAUD(FINAL_VALUE);
        setPaymentValues(new_values);
    };

    const handlePaymentValueChange = (prop) => (event) => {
        setPaymentValues({ ...paymentValues, [prop]: event.target.value });
    };

    const [loadPrices, setLoadPrices] = useState(print ? true : false);
    const classes = useStyles();

    function ColourComponent(props) {
        let colour = props.colour;
        if (colour && GetHTMLColour(props.colour)[0] == "")
            colour = colour
                .replace(" TW", "")
                .replace(" AM", "")
                .replace(" LL", "")
                .replace(" ST", "")
                .replace(" HP", "");
        var htmlcolours = GetHTMLColour(colour);
        var top_bg_colour = htmlcolours[0];
        var bottom_bg2_colour = htmlcolours[1];
        var bg1 = "linear-gradient(165deg, " + top_bg_colour + " 65%, " + bottom_bg2_colour + " 35%)";
        if (top_bg_colour === bottom_bg2_colour) bg1 = top_bg_colour;
        var text_colour1 = htmlcolours[2];

        return (
            <div className={classes.colour_panel} style={{ background: bg1, color: text_colour1 }}>
                {props.label}: {colour}
            </div>
        );
    }

    const threeDmouseClick = (e) => {
        if (e.target.style.backgroundSize === "contain") e.target.style.backgroundSize = "cover";
        else e.target.style.backgroundSize = "contain";
        e.target.style.backgroundPosition = "50% 50%";
    };

    const toAUD = (val) => {
        return toNumber(val).toLocaleString("en-AU", {
            style: "currency",
            currency: "AUD",
        });
    };

    const calculatePrices = (source = "") => {
        let INSTALLATION_BASE_PRICE = job.QuoteParameters?.BOM?.InstallationList?.total_price;
        if (!INSTALLATION_BASE_PRICE) INSTALLATION_BASE_PRICE = 0;

        const PACKING_AND_DELIVERY = job.Distributor?.DeliveryFee + job.Distributor?.PackingFee;

        const MATERIAL_FIXED_PRICE = toNumber(
            print ? pricingParameters?.MaterialFixedPrice : values.material,
            false,
            true
        );
        const INSTALL_FIXED_PRICE = toNumber(
            print ? pricingParameters?.InstallationFixedPrice : values.installation,
            false,
            true
        );

        const EXTRA_COSTS = toNumber(print ? pricingParameters?.ExtraCostsFixedPrice : values.extra, false, true);

        let PRICING_OUTPUT_SUMMARY = {
            MaterialBase: displayOnlyPrice ? displayOnlyPrice : MATERIAL_KIT_PRICE_FROM_EPRICING,
            InstallationBase: INSTALLATION_BASE_PRICE,
        };

        let SUBTOTAL = 0;
        let promo_discount = values.promo_discount / 100;

        if (!promo_discount) promo_discount = 0;

        let kitPrice = displayOnlyPrice ? displayOnlyPrice : MATERIAL_KIT_PRICE_FROM_EPRICING;
        let DISCOUNTED_KIT_PRICE_FROM_EPRICING = kitPrice - kitPrice * promo_discount;

        PRICING_OUTPUT_SUMMARY["MaterialDiscountedPromo"] = DISCOUNTED_KIT_PRICE_FROM_EPRICING;

        let markup_Material = Number(markupStructure["Material"]) / 100;
        if (!markup_Material) markup_Material = 0;
        let markup_Installation = Number(markupStructure["Installation"]) / 100;
        if (!markup_Installation) markup_Installation = 0;
        let markup_Commission = Number(markupStructure["Commission"]) / 100;
        if (!markup_Commission) markup_Commission = 0;

        //material price
        let material = DISCOUNTED_KIT_PRICE_FROM_EPRICING + DISCOUNTED_KIT_PRICE_FROM_EPRICING * markup_Material;

        PRICING_OUTPUT_SUMMARY["MaterialMargin"] = DISCOUNTED_KIT_PRICE_FROM_EPRICING * markup_Material;
        let material_commission = material * markup_Commission;
        PRICING_OUTPUT_SUMMARY["MaterialCommission"] = material_commission;
        material += material_commission;

        if (MATERIAL_FIXED_PRICE) material = Number(MATERIAL_FIXED_PRICE);
        PRICING_OUTPUT_SUMMARY["MaterialSubtotal"] = material;

        //installation price
        let installation = INSTALLATION_BASE_PRICE + INSTALLATION_BASE_PRICE * markup_Installation;
        PRICING_OUTPUT_SUMMARY["InstallationMargin"] = INSTALLATION_BASE_PRICE * markup_Installation;
        let installation_commission = installation * markup_Commission;
        PRICING_OUTPUT_SUMMARY["InstallationCommission"] = installation_commission;
        installation += installation_commission;

        PRICING_OUTPUT_SUMMARY["CommissionTotal"] = material_commission + installation_commission;
        installation = Number(INSTALL_FIXED_PRICE);
        PRICING_OUTPUT_SUMMARY["InstallationSubtotal"] = Number(installation);

        SUBTOTAL = material + installation;
        PRICING_OUTPUT_SUMMARY["InstallationANDMaterialSubtotal"] = SUBTOTAL;

        //overall discount
        let overall_discount = toNumber(print ? pricingParameters?.OverallDiscount : values.discount, false, true);
        let overall_discount_percentage = toNumber(
            print ? pricingParameters?.OverallDiscountPercentage : values.discount_percentage,
            false,
            true
        );
        if (source === "discount_percentage") {
            overall_discount = SUBTOTAL * (overall_discount_percentage / 100);
        } else {
            overall_discount_percentage = (overall_discount / SUBTOTAL) * 100;
        }

        PRICING_OUTPUT_SUMMARY["OverallDiscount"] = overall_discount;
        SUBTOTAL -= overall_discount;

        //plus extra costs
        SUBTOTAL += EXTRA_COSTS;
        PRICING_OUTPUT_SUMMARY["InstallationANDMaterialANDExtraSubtotal"] = SUBTOTAL;

        //plus packing and delivery
        let markup_PackingAndDel = Number(markupStructure["PackingAndDel"]) / 100;
        let PACKING_AND_DEL_MARKED_UP = PACKING_AND_DELIVERY + PACKING_AND_DELIVERY * markup_PackingAndDel;
        SUBTOTAL += PACKING_AND_DEL_MARKED_UP;
        PRICING_OUTPUT_SUMMARY["PackingAndDelBase"] = PACKING_AND_DELIVERY;
        PRICING_OUTPUT_SUMMARY["PackingAndDelMarkedUp"] = PACKING_AND_DEL_MARKED_UP;

        let totalExGST = SUBTOTAL;

        PRICING_OUTPUT_SUMMARY["TotalExGST"] = totalExGST;

        let GST = totalExGST * 0.1;
        let totalIncGST = totalExGST + GST;

        PRICING_OUTPUT_SUMMARY["TotalIncGST"] = totalIncGST;
        PRICING_OUTPUT_SUMMARY["price_error_summary"] = PRICE_ERROR_SUMMARY;

        if (props.updateJobState) {
            props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "MaterialFixedPrice", material);
            props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "InstallationFixedPrice", installation);
            props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "OverallDiscount", overall_discount);
            props.updateJobState(
                "QuoteParameters.PRICING_PARAMETERS",
                "OverallDiscountPercentage",
                overall_discount_percentage
            );
            props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "ExtraCostsFixedPrice", EXTRA_COSTS);
            props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "OutputSummary", PRICING_OUTPUT_SUMMARY);
        }

        setValues({
            ...values,
            material: toAUD(material),
            installation: toAUD(installation),
            subtotal: toAUD(PRICING_OUTPUT_SUMMARY["InstallationANDMaterialSubtotal"]),
            discount: overall_discount === 0 ? " " : toAUD(overall_discount),
            discount_percentage:
                overall_discount_percentage === 0 ? "0%" : overall_discount_percentage.toFixed(1) + "%",
            extra: toAUD(EXTRA_COSTS),
            packing_and_del: toAUD(PACKING_AND_DEL_MARKED_UP),
            gst: toAUD(GST),
            total: toAUD(totalIncGST),
        });

        updatePP(source, null, totalIncGST);
        setPricingSummary(PRICING_OUTPUT_SUMMARY);
    };

    useEffect(() => {
        calculatePrices();
    }, [loadPrices]);

    useEffect(() => {
        calculatePrices();
    }, [values.promo_discount, values.extra]);

    useEffect(() => {
        if (toNumber(pricingParameters?.ExtraCostsFixedPrice) != toNumber(values.extra)) {
            setValues({ ...values, extra: pricingParameters?.ExtraCostsFixedPrice });
        }
    }, [pricingParameters?.ExtraCostsFixedPrice]);

    const [menuOpen, setMenuOpen] = useState(null);
    const handleMenuClick = (event, name) => {
        setMenuOpen({ ...menuOpen, [name]: event.target });
    };
    const handleMenuClose = (event, name) => {
        setMenuOpen({ ...menuOpen, [name]: false });
    };

    if (!loadPrices) setLoadPrices(true);

    let this_area = null;
    if (job.AreaSpecifications && job.AreaSpecifications[0]) this_area = job.AreaSpecifications[0];

    const DeckMode = job?.DesignParameters?.DeckMode === 1;
    const LouvreMode = job?.DesignParameters?.LouvreMode === 1;
    const carportMode = job?.DesignParameters?.CarportMode === 1;

    let beamNameAndColour1 = getBeamDetails(1, this_area);
    let beamNameAndColour2 = getBeamDetails(2, this_area);
    let beamNameAndColour3 = getBeamDetails(3, this_area);
    let beamNameAndColour4 = getBeamDetails(4, this_area);

    let columnColour = isTrue(
        this_area.BEAMS_AND_POSTS.PostColourSelectionMade,
        this_area.BEAMS_AND_POSTS.PostColourSelected
    )
        ? this_area.BEAMS_AND_POSTS.PostCol
            ? this_area.BEAMS_AND_POSTS.PostCol
            : this_area.BEAMS_AND_POSTS.PostColour
        : "TBA";

    if (
        this_area.BEAMS_AND_POSTS.PostColourSelectionMade === undefined &&
        this_area.BEAMS_AND_POSTS.PostColourSelected === undefined
    )
        columnColour = this_area.BEAMS_AND_POSTS.PostCol
            ? this_area.BEAMS_AND_POSTS.PostCol
            : this_area.BEAMS_AND_POSTS.PostColour;

    let roofColour = isTrue(this_area.ROOF_SHEETING.RoofColourSelectionMade, this_area.ROOF_SHEETING.RoofColourSelected)
        ? this_area.ROOF_SHEETING.RoofSheetColour
            ? this_area.ROOF_SHEETING.RoofSheetColour
            : this_area.ROOF_SHEETING.RoofColour
        : "TBA";

    let flashingColour = this_area.ROOF_SHEETING.FlashingColour
        ? this_area.ROOF_SHEETING.FlashingColour
        : this_area.ROOF_SHEETING.FlashingCol;

    let gutterColour = isTrue(
        this_area.GUTTERS_AND_DOWNPIPES.GutterColourSelectionMade,
        this_area.GUTTERS_AND_DOWNPIPES.GutterColourSelected
    )
        ? this_area.GUTTERS_AND_DOWNPIPES.GutterColour
            ? this_area.GUTTERS_AND_DOWNPIPES.GutterColour
            : this_area.GUTTERS_AND_DOWNPIPES.GutterCol
        : "TBA";

    if (
        this_area.GUTTERS_AND_DOWNPIPES.GutterColourSelectionMade === undefined &&
        this_area.GUTTERS_AND_DOWNPIPES.GutterColourSelected === undefined
    )
        gutterColour = this_area.GUTTERS_AND_DOWNPIPES.GutterColour
            ? this_area.GUTTERS_AND_DOWNPIPES.GutterColour
            : this_area.GUTTERS_AND_DOWNPIPES.GutterCol;

    let downpipeColour = "TBA";
    let hasDownpipe = this_area?.GUTTERS_AND_DOWNPIPES?.DownpipeIsSelected;

    if (hasDownpipe) {
        downpipeColour = this_area?.GUTTERS_AND_DOWNPIPES?.DownpipeCol || "TBA";
    }

    let windzone = job.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.importance_level_2?.windzone_equiv;
    if (!windzone) windzone = job.SiteParameters?.WindData?.WindZone;
    if (!windzone) windzone = "NA";
    let blocking = job.SiteParameters?.WindData?.Blocking;
    if (blocking === undefined) blocking = "NA";
    windzone += "b" + blocking;

    let businessLogo;
    let twodlayout;
    let threedlayout = job?.QuoteParameters?.DOCUMENTS?.["3DScreenShots"]?.[0] ?? "";

    if (window.location.href.includes("GamaReport") || print) {
        // Report-Gen
        businessLogo = props.businessLogo ?? "";
        twodlayout = props.layout_all ?? "";
        threedlayout = props.threed_layout ?? "";
    } else {
        // Design-Cloud
        businessLogo = API_BASE() + "document/BUS_" + job.Distributor.Code + "/" + job.Distributor.Logo;
        twodlayout = API_BASE() + "document/" + job.id + "/layout_all.svg";
        threedlayout = threedlayout ? API_BASE() + "document/" + job.id + "/" + threedlayout : "";
    }

    const showDeposit = parseFloat(paymentValues.deposit_percent) > 0 || !print;
    const showPayment1 = parseFloat(paymentValues.pp1_percent) > 0 || !print;
    const showPayment2 = parseFloat(paymentValues.pp2_percent) > 0 || !print;
    const showPayment3 = parseFloat(paymentValues.pp3_percent) > 0 || !print;

    let payment2DisplayAs = showPayment1 ? "Payment 2" : "Payment 1";
    let payment3DisplayAs;

    if (showPayment1 && showPayment2) {
        payment3DisplayAs = "Payment 3";
    } else if (showPayment1 || showPayment2) {
        payment3DisplayAs = "Payment 2";
    } else {
        payment3DisplayAs = "Payment 1";
    }

    return (
        <div>
            <div className="portrait_page">
                <div className="subpage">
                    <Header
                        title={GetDesignStringShort(job.AreaSpecifications) + " for " + job.Customer.JobName}
                        manufacturer={manufacturer}
                        {...props}
                    />

                    <div className={classes.flex}>
                        <div
                            style={{
                                flex: 3,
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "center",
                            }}
                        >
                            {job.Distributor.Logo && <img className={classes.business_logo} src={businessLogo} />}
                            {!job.Distributor.Logo && (
                                <div className={classes.business_name}>{job.Distributor.Name}</div>
                            )}

                            <Box
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#dbdbdb",
                                        transition: "background-color 0.3s ease",
                                    },
                                }}
                                onClick={handleClickOpen}
                                className={classes.business_details}
                            >
                                {buisnessDetails.name ? (
                                    <>
                                        {buisnessDetails.name}
                                        <br />
                                    </>
                                ) : (
                                    ""
                                )}
                                {buisnessDetails.address}
                                <br />
                                {buisnessDetails.abn ? (
                                    <>
                                        ABN: {buisnessDetails.abn}
                                        <br />
                                    </>
                                ) : (
                                    ""
                                )}
                                {buisnessDetails.email ? (
                                    <>
                                        {buisnessDetails.email}
                                        <br />
                                    </>
                                ) : (
                                    ""
                                )}
                                {buisnessDetails.phone ? (
                                    <>
                                        {buisnessDetails.phone}
                                        <br />
                                    </>
                                ) : (
                                    ""
                                )}
                                {buisnessDetails.licence && (
                                    <>
                                        Building Licence: {buisnessDetails.licence} <br />
                                    </>
                                )}
                            </Box>
                        </div>
                        <div style={{ flex: 4 }}>
                            <div className={classes.header}>CUSTOMER DETAILS</div>
                            <div className={classes.flex}>
                                <CustomTextField
                                    id="standard-basic"
                                    label="First Name"
                                    value={customerValues.FirstName}
                                    onChange={handleCustomerChange("FirstName")}
                                    onBlur={(e) => {
                                        props.updateJobState("Customer", "FirstName", e.target.value);
                                    }}
                                />
                                <CustomTextField
                                    id="standard-basic"
                                    label="Last Name"
                                    value={customerValues.LastName}
                                    onChange={handleCustomerChange("LastName")}
                                    onBlur={(e) => props.updateJobState("Customer", "LastName", e.target.value)}
                                />
                            </div>
                            <div className={classes.flex}>
                                <CustomTextField
                                    disabled={!print}
                                    id="standard-basic"
                                    label="Site Address"
                                    value={job.SiteParameters.Address.FormattedAddress.split(",")[0]}
                                />
                            </div>
                            <div className={classes.flex}>
                                <CustomTextField
                                    disabled={!print}
                                    id="standard-basic"
                                    label="Suburb"
                                    value={job.SiteParameters.Address.Suburb}
                                />
                                <CustomTextField
                                    disabled={!print}
                                    id="standard-basic"
                                    style={{ flex: "unset", width: "50px" }}
                                    label="State"
                                    value={job.SiteParameters.Address.State}
                                />
                                <CustomTextField
                                    id="standard-basic"
                                    label="Phone"
                                    value={customerValues.Phone}
                                    onChange={handleCustomerChange("Phone")}
                                    onBlur={(e) => props.updateJobState("Customer", "Phone", e.target.value)}
                                />
                            </div>
                        </div>
                        <div style={{ flex: 3 }}>
                            <div className={classes.header}>JOB DETAILS</div>
                            <div className={classes.flex}>
                                <CustomTextField
                                    id="standard-basic"
                                    label="Email"
                                    value={customerValues.Email}
                                    onChange={handleCustomerChange("Email")}
                                    onBlur={(e) => props.updateJobState("Customer", "Email", e.target.value)}
                                />
                            </div>
                            <div className={classes.flex}>
                                <CustomTextField
                                    id="standard-basic"
                                    label="Job Name (Cust Ref)"
                                    value={customerValues.JobName}
                                    onChange={handleCustomerChange("JobName")}
                                    onBlur={(e) => props.updateJobState("Customer", "JobName", e.target.value)}
                                />
                                <CustomTextField
                                    disabled={!print}
                                    id="standard-basic"
                                    label="Wind"
                                    style={{ flex: "unset", width: "50px" }}
                                    value={windzone}
                                />
                            </div>
                            <div className={classes.flex}>
                                <CustomTextField
                                    id="standard-basic"
                                    label="Delivery Notes"
                                    value={customerValues.DeliveryNotes}
                                    onChange={handleCustomerChange("DeliveryNotes")}
                                    onBlur={(e) =>
                                        props.updateJobState("SiteParameters", "DeliveryNotes", e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <Grid
                        container
                        spacing={1}
                        style={{
                            height: "860px",
                            overflow: "hidden",
                        }}
                    >
                        <Grid
                            item
                            xs={5}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                maxHeight: "100%",
                            }}
                        >
                            <div className={classes.header} style={{ display: "flex" }}>
                                <span style={{ flex: 1, paddingLeft: print ? "0px" : "32px" }}>QUOTATION</span>
                                {!print && (
                                    <IconButton
                                        className={classes.context_menu_button}
                                        aria-label="delete"
                                        color="primary"
                                        onClick={(event) => handleMenuClick(event, "Quote")}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                )}
                            </div>
                            <div
                                className={
                                    classes.flex +
                                    (isTrue(
                                        pricingParameters?.HideMaterialAndInstallPrices,
                                        pricingParameters?.OnlyShowTotal
                                    )
                                        ? " hidden"
                                        : "")
                                }
                            >
                                <span className={classes.row_header}>Materials</span>
                                <input
                                    className={classes.pricing_input + (print ? " no-border" : "")}
                                    type="text"
                                    value={values.material}
                                    onFocus={handleFocus}
                                    onChange={handleChange("material")}
                                    onBlur={(e) => calculatePrices()}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") e.target.blur();
                                    }}
                                />
                            </div>
                            <div
                                className={
                                    classes.flex +
                                    (isTrue(
                                        pricingParameters?.HideMaterialAndInstallPrices,
                                        pricingParameters?.OnlyShowTotal
                                    )
                                        ? " hidden"
                                        : "")
                                }
                            >
                                <span className={classes.row_header}>Installation</span>
                                <input
                                    className={classes.pricing_input + (print ? " no-border" : "")}
                                    type="text"
                                    value={values.installation}
                                    onFocus={handleFocus}
                                    onChange={handleChange("installation")}
                                    onBlur={(e) => calculatePrices("installation")}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") e.target.blur();
                                    }}
                                />
                            </div>
                            <div
                                className={classes.flex + (isTrue(pricingParameters?.OnlyShowTotal) ? " hidden" : "")}
                                style={{
                                    background: "#8ec5d7",
                                    color: "white",
                                    height: "24px",
                                    whiteSpace: "nowrap",
                                    fontWeight: "600",
                                    fontSize: "0.8rem",
                                }}
                            >
                                <span className={classes.row_header} style={{ marginTop: "3px" }}>
                                    {toNumber(values.installation) > 0 ? "SUPPLY AND INSTALL" : "SUPPLY ONLY"}
                                </span>
                                <div className={classes.pricing_input + " " + classes.pricing_SUBTOTAL}>
                                    {values.subtotal}
                                </div>
                            </div>
                            <div
                                className={
                                    classes.flex +
                                    ((print && toNumber(values.discount) < 1) ||
                                    isTrue(pricingParameters?.OnlyShowTotal)
                                        ? " hidden"
                                        : "")
                                }
                            >
                                <span
                                    className={classes.row_header}
                                    style={toNumber(values.discount) > 0 ? {} : { color: "darkgrey" }}
                                >
                                    - Discount
                                </span>
                                <input
                                    className={classes.pricing_input + (print ? " no-border" : "")}
                                    type="text"
                                    value={values.discount_percentage}
                                    onFocus={handleFocus}
                                    onChange={handleChange("discount_percentage")}
                                    onBlur={(e) => calculatePrices("discount_percentage")}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") e.target.blur();
                                    }}
                                />
                                <input
                                    className={classes.pricing_input + (print ? " no-border" : "")}
                                    style={print ? { color: "#561d1d" } : {}}
                                    type="text"
                                    value={print ? "(" + values.discount + ")" : values.discount}
                                    onFocus={handleFocus}
                                    onChange={handleChange("discount")}
                                    onBlur={(e) => calculatePrices()}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") e.target.blur();
                                    }}
                                />
                            </div>
                            <div
                                className={
                                    classes.flex +
                                    ((print && toNumber(values.extra) < 1) || isTrue(pricingParameters?.OnlyShowTotal)
                                        ? " hidden"
                                        : "")
                                }
                                onClick={() => props.setShowEditExtraItems(true)}
                            >
                                <span className={classes.row_header}>+ Extra Items</span>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        flexDirection: "column",
                                    }}
                                >
                                    {pricingParameters?.ShowExtraItemsBreakDownOnQuote &&
                                        pricingParameters?.ExtraItems &&
                                        Object.keys(pricingParameters?.ExtraItems).map((key, index) => {
                                            if (pricingParameters?.ExtraItems[key].Subtotal > 0)
                                                return (
                                                    <div key={index} className={classes.extra_item_text}>
                                                        {pricingParameters?.ExtraItems[key].Qty} x{" "}
                                                        {pricingParameters?.ExtraItems[key].Name} ={" "}
                                                        {toAUD(pricingParameters?.ExtraItems[key].Subtotal)}
                                                    </div>
                                                );
                                        })}
                                    <div
                                        className={classes.pricing_input + (print ? " no-border" : " " + classes.linky)}
                                        style={
                                            pricingParameters?.ShowExtraItemsBreakDownOnQuote &&
                                            Object.keys(pricingParameters?.ExtraItems).length > 0
                                                ? { borderTop: "1px dotted #778899 !important" }
                                                : {}
                                        }
                                    >
                                        {toAUD(values.extra)}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.flex + (isTrue(pricingParameters?.OnlyShowTotal) ? " hidden" : "")}>
                                <span className={classes.row_header}>
                                    {window.LYSAGHT ? "+ Delivery" : "+ Packing and Delivery"}
                                </span>
                                <div
                                    className={
                                        classes.pricing_input +
                                        " " +
                                        classes.not_editable +
                                        (print ? " black-text" : "")
                                    }
                                >
                                    {values.packing_and_del}
                                </div>
                            </div>
                            <div className={classes.flex + (isTrue(pricingParameters?.OnlyShowTotal) ? " hidden" : "")}>
                                <span className={classes.row_header}>+ GST</span>
                                <div
                                    className={
                                        classes.pricing_input +
                                        " " +
                                        classes.not_editable +
                                        (print ? " black-text" : "")
                                    }
                                >
                                    {values.gst}
                                </div>
                            </div>
                            <div
                                className={classes.flex}
                                style={{
                                    background: "steelblue",
                                    color: "white",
                                    whiteSpace: "nowrap",
                                    fontWeight: "600",
                                }}
                            >
                                <span className={classes.row_header}>
                                    TOTAL
                                    <br />
                                    (inc-GST)
                                </span>
                                <div className={classes.pricing_input + " " + classes.pricing_TOTAL}>
                                    {values.total}
                                </div>
                            </div>
                            <div
                                className={classes.flex + (!isTrue(pricingParameters?.OnlyShowTotal) ? " hidden" : "")}
                            >
                                <span className={classes.row_header}> GST</span>
                                <div
                                    className={
                                        classes.pricing_input +
                                        " " +
                                        classes.not_editable +
                                        (print ? " black-text" : "")
                                    }
                                >
                                    {values.gst}
                                </div>
                            </div>

                            <div className={classes.pricing_notes}>
                                *extra fees may apply if specified time drop is required.
                            </div>
                            <div
                                className={
                                    classes.header +
                                    (isTrue(pricingParameters?.HideQRCode || carportMode) ? " hidden" : "")
                                }
                                style={{ background: "darkgrey", display: "flex" }}
                            >
                                <span style={{ flex: 1, paddingLeft: print ? "0px" : "32px" }}>3D VIEW QR CODE</span>
                                {!print && (
                                    <IconButton
                                        className={classes.context_menu_button}
                                        aria-label="delete"
                                        color="primary"
                                        onClick={(event) => handleMenuClick(event, "Qr")}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                )}
                            </div>
                            {twodlayout && (
                                <div
                                    className={
                                        classes.qrContainer +
                                        (isTrue(pricingParameters?.HideQRCode || carportMode) ? " hidden" : "")
                                    }
                                >
                                    <>
                                        <QRCodeSVG className={classes.qrSVG} value={brandRedirect} size={88} />{" "}
                                        {documentParameters?.showQrLink && (
                                            <p className={classes.qrURL}>
                                                <a href={brandRedirect}>{brandRedirect}</a>
                                            </p>
                                        )}
                                    </>
                                </div>
                            )}
                            <div
                                className={
                                    classes.header + (isTrue(pricingParameters?.HidePaymentStructure) ? " hidden" : "")
                                }
                                style={{ background: "darkgrey" }}
                            >
                                PAYMENT STRUCTURE
                            </div>

                            <div
                                className={
                                    classes.flex_row +
                                    (isTrue(pricingParameters?.HidePaymentStructure) ? " hidden" : "")
                                }
                            >
                                {showDeposit && (
                                    <div className={classes.pay_section} style={{ borderLeft: "none" }}>
                                        <div className={classes.pay_header}>Deposit</div>
                                        <input
                                            className={classes.pay_input}
                                            style={{ color: "darkred" }}
                                            type="text"
                                            value={paymentValues.deposit_percent}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("deposit_percent")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Deposit", toNumber(e.target.value) + "%");
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />

                                        <input
                                            className={classes.pay_input}
                                            type="text"
                                            value={paymentValues.deposit}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("deposit")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Deposit", toNumber(e.target.value));
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />
                                    </div>
                                )}
                                {showPayment1 && (
                                    <div className={classes.pay_section}>
                                        <div className={classes.pay_header}>Payment 1</div>
                                        <input
                                            className={classes.pay_input}
                                            style={{ color: "darkred" }}
                                            type="text"
                                            value={paymentValues.pp1_percent}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("pp1_percent")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Progress1", toNumber(e.target.value) + "%");
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />

                                        <input
                                            className={classes.pay_input}
                                            type="text"
                                            value={paymentValues.pp1}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("pp1")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Progress1", toNumber(e.target.value));
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />
                                    </div>
                                )}
                                {showPayment2 && (
                                    <div className={classes.pay_section}>
                                        <div className={classes.pay_header}>{payment2DisplayAs}</div>
                                        <input
                                            className={classes.pay_input}
                                            style={{ color: "darkred" }}
                                            type="text"
                                            value={paymentValues.pp2_percent}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("pp2_percent")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Progress2", toNumber(e.target.value) + "%");
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />
                                        <input
                                            className={classes.pay_input}
                                            type="text"
                                            value={paymentValues.pp2}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("pp2")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Progress2", toNumber(e.target.value));
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />
                                    </div>
                                )}
                                {showPayment3 && (
                                    <div className={classes.pay_section}>
                                        <div className={classes.pay_header}>{payment3DisplayAs}</div>
                                        <input
                                            className={classes.pay_input}
                                            style={{ color: "darkred" }}
                                            type="text"
                                            value={paymentValues.pp3_percent}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("pp3_percent")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Progress3", toNumber(e.target.value) + "%");
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />
                                        <input
                                            className={classes.pay_input}
                                            type="text"
                                            value={paymentValues.pp3}
                                            onFocus={(e) => handleSetEnter(e)}
                                            onChange={handlePaymentValueChange("pp3")}
                                            onBlur={(e) => {
                                                if (e.target.value !== enterValue)
                                                    updatePP("Progress3", toNumber(e.target.value));
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") e.target.blur();
                                            }}
                                        />
                                    </div>
                                )}
                                <div className={classes.pay_section}>
                                    <div className={classes.pay_header}>Final</div>
                                    <input
                                        className={classes.pay_input}
                                        disabled
                                        type="text"
                                        value={paymentValues.final_percent}
                                    />
                                    <input
                                        className={classes.pay_input}
                                        disabled
                                        type="text"
                                        value={paymentValues.final}
                                    />
                                </div>
                            </div>

                            <div className={classes.header}>CONTRACT ACCEPTANCE</div>
                            <div className={classes.acceptance}>
                                Please print your name, sign and date the box below. By signing this declaration, this
                                quotation becomes a CONTRACT. You agree to the terms and conditions and the price of{" "}
                                {values.total}.
                            </div>
                            <div className={classes.sign}></div>
                            <div className={classes.header} style={{ display: "flex" }}>
                                <span style={{ flex: 1, paddingLeft: print ? "0px" : "32px" }}>NOTES</span>
                                {!print && defaultJobNotes?.length > 0 && (
                                    <IconButton
                                        className={classes.context_menu_button}
                                        aria-label="delete"
                                        color="primary"
                                        onClick={(event) => handleMenuClick(event, "Notes")}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                )}
                            </div>
                            {print && <p className={classes.notes_display}>{pricingParameters?.Notes}</p>}
                            {!print && (
                                <React.Fragment>
                                    <textarea
                                        ref={notesAreaRef}
                                        name="textValue"
                                        className={classes.notes}
                                        value={notes}
                                        onChange={handleNotesChange}
                                        onBlur={(e) =>
                                            props.updateJobState(
                                                "QuoteParameters.PRICING_PARAMETERS",
                                                "Notes",
                                                e.target.value
                                            )
                                        }
                                    />
                                </React.Fragment>
                            )}
                        </Grid>
                        <Grid
                            item
                            xs={7}
                            style={{
                                maxHeight: "100%",
                            }}
                        >
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <div className={classes.header} style={{ display: "flex" }}>
                                    <span style={{ flex: 1, paddingLeft: print ? "0px" : "32px" }}>
                                        DESIGN SPECIFICATIONS
                                    </span>
                                    {!print && (
                                        <IconButton
                                            className={classes.context_menu_button}
                                            aria-label="delete"
                                            color="primary"
                                            onClick={(event) => handleMenuClick(event, "Design")}
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                    )}
                                </div>

                                {twodlayout && (
                                    <div
                                        className={classes.svg_layout}
                                        style={{
                                            margin: `${(rotate / 90) % 2 === 0 ? "" : "35px"}`,
                                            height: "70mm !important",
                                            backgroundImage: 'url("' + twodlayout + '")',
                                            transform: `rotate(${rotate}deg) scale(0.95)`,
                                        }}
                                    ></div>
                                )}

                                {threedlayout && (
                                    <div
                                        className={classes.threedlayout}
                                        onClick={threeDmouseClick}
                                        style={{
                                            backgroundImage: "url(" + threedlayout + ")",
                                            backgroundPosition: "50% 50%",
                                        }}
                                    ></div>
                                )}
                                <div className={classes.header} style={{ background: "darkgrey" }}>
                                    COLOUR SUMMARY
                                    {job.AreaSpecifications.length > 1 ? " (area 1 only)" : ""}
                                </div>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    {LouvreMode ? (
                                        <>
                                            <div style={{ flex: 1 }}>
                                                <ColourComponent colour={roofColour} label="Kit Colour" />
                                            </div>
                                        </>
                                    ) : DeckMode ? (
                                        <>
                                            <div style={{ flex: 1 }}>
                                                {beamNameAndColour1 && (
                                                    <ColourComponent
                                                        colour={beamNameAndColour1.colour}
                                                        label={beamNameAndColour1.name}
                                                    />
                                                )}
                                                {beamNameAndColour2 && (
                                                    <ColourComponent
                                                        colour={beamNameAndColour2.colour}
                                                        label={beamNameAndColour2.name}
                                                    />
                                                )}
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <ColourComponent colour={columnColour} label="Column" />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ flex: 1 }}>
                                                {beamNameAndColour1 && (
                                                    <ColourComponent
                                                        colour={beamNameAndColour1.colour}
                                                        label={beamNameAndColour1.name}
                                                    />
                                                )}
                                                {beamNameAndColour2 && (
                                                    <ColourComponent
                                                        colour={beamNameAndColour2.colour}
                                                        label={beamNameAndColour2.name}
                                                    />
                                                )}
                                                {beamNameAndColour3 && (
                                                    <ColourComponent
                                                        colour={beamNameAndColour3.colour}
                                                        label={beamNameAndColour3.name}
                                                    />
                                                )}
                                                {beamNameAndColour4 && (
                                                    <ColourComponent
                                                        colour={beamNameAndColour4.colour}
                                                        label={beamNameAndColour4.name}
                                                    />
                                                )}
                                                {hasDownpipe && (
                                                    <ColourComponent colour={downpipeColour} label="Downpipe" />
                                                )}
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <ColourComponent colour={columnColour} label="Column" />
                                                <ColourComponent
                                                    colour={roofColour}
                                                    reverse={this_area.ROOF_SHEETING.RoofRolling.includes("Under")}
                                                    label="Roof"
                                                />
                                                <ColourComponent colour={flashingColour} label="Flashing" />
                                                <ColourComponent colour={gutterColour} label="Gutter" />
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div style={{ flex: 1, minHeight: "230px" }}>{GenerateSummary(job)}</div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                {page_number !== undefined && <Footer footer_text={footer_text} page_number={page_number} />}
            </div>
            <Menu
                id="simple-menu-quote"
                anchorEl={menuOpen?.Quote ?? null}
                open={Boolean(menuOpen?.Quote ?? false)}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={(event) => handleMenuClose(event, "Quote")}
            >
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                    }}
                    control={
                        <Switch
                            checked={pricingParameters?.HideMaterialAndInstallPrices ?? false}
                            color="primary"
                            onChange={(e) =>
                                props.updateJobState(
                                    "QuoteParameters.PRICING_PARAMETERS",
                                    "HideMaterialAndInstallPrices",
                                    e.target.checked
                                )
                            }
                            name="checkedA"
                        />
                    }
                    label="Hide Material and Installation Price"
                />
                <br />
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                    }}
                    control={
                        <Switch
                            checked={pricingParameters?.OnlyShowTotal ?? false}
                            color="primary"
                            onChange={(e) =>
                                props.updateJobState(
                                    "QuoteParameters.PRICING_PARAMETERS",
                                    "OnlyShowTotal",
                                    e.target.checked
                                )
                            }
                            name="checkedA"
                        />
                    }
                    label="Only Show Total"
                />
                <br />
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                    }}
                    control={
                        <Switch
                            checked={pricingParameters?.HideQRCode ?? false}
                            color="primary"
                            onChange={(e) =>
                                props.updateJobState(
                                    "QuoteParameters.PRICING_PARAMETERS",
                                    "HideQRCode",
                                    e.target.checked
                                )
                            }
                            name="checkedA"
                        />
                    }
                    label="Hide 3D Model QR Code"
                />
                <br />
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                    }}
                    control={
                        <Switch
                            checked={pricingParameters?.HidePaymentStructure ?? false}
                            color="primary"
                            onChange={(e) =>
                                props.updateJobState(
                                    "QuoteParameters.PRICING_PARAMETERS",
                                    "HidePaymentStructure",
                                    e.target.checked
                                )
                            }
                            name="checkedA"
                        />
                    }
                    label="Hide Payment Structure"
                />
                <br />
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                    }}
                    control={
                        <Switch
                            checked={documentParameters?.showElevations ?? false}
                            color="primary"
                            onChange={(e) =>
                                props.updateJobState("QuoteParameters.DOCUMENTS", "showElevations", e.target.checked)
                            }
                            name="checkedA"
                        />
                    }
                    label="Add Elevations"
                />
                <br />
                {window.LYSAGHT && (
                    <FormControlLabel
                        style={{
                            marginLeft: "5px",
                        }}
                        control={
                            <Switch
                                checked={documentParameters?.appendTermsAndConditions ?? false}
                                color="primary"
                                onChange={(e) =>
                                    props.updateJobState(
                                        "QuoteParameters.DOCUMENTS",
                                        "appendTermsAndConditions",
                                        e.target.checked
                                    )
                                }
                                name="checkedA"
                            />
                        }
                        label="Append Terms & Conditions"
                    />
                )}
                {!print && (toNumber(user?.Role) >= 10 || user.RoleName === "Super") && <hr /> && (
                    <div style={{ margin: "5px", whiteSpace: "pre-wrap" }}>
                        <strong>PRICING SUMMARY (Admin Only)</strong>
                        <br />
                        Order Material Cost: {toAUD(MATERIAL_KIT_PRICE_FROM_EPRICING)}
                        <br />
                        {displayOnlyPrice > 0 && (
                            <>
                                Business Discount: {toAUD(displayOnlyDiscount)}
                                <br />
                                Total: {toAUD(displayOnlyPrice)}
                                <br />
                            </>
                        )}
                        <br />
                        {toNumber(values.promo_discount) > 0 && (
                            <>
                                Promo Discount: {toNumber(values.promo_discount)}%<br />
                            </>
                        )}
                        <>
                            Customer Type: {customer_type} - Markup: {markupStructure["Material"]}%,{" "}
                            {toAUD(pricingSummary.MaterialMargin)}
                            <br />
                        </>
                    </div>
                )}
            </Menu>
            <Menu
                id="simple-menu-design"
                anchorEl={menuOpen?.Design ?? null}
                open={Boolean(menuOpen?.Design ?? false)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={(event) => handleMenuClose(event, "Design")}
            >
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                    }}
                    control={
                        <Button
                            onClick={() =>
                                props.updateJobState("QuoteParameters.DOCUMENTS", "rotate", rotate ? rotate + 90 : 90)
                            }
                            name="checkedA"
                        />
                    }
                    label="Rotate 90 Degrees"
                />
                <br />
            </Menu>
            <Menu
                id="simple-menu-qr"
                anchorEl={menuOpen?.Qr ?? null}
                open={Boolean(menuOpen?.Qr ?? false)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={(event) => handleMenuClose(event, "Qr")}
            >
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                    }}
                    control={
                        <Switch
                            checked={documentParameters?.showQrLink}
                            color="primary"
                            onChange={(e) =>
                                props.updateJobState("QuoteParameters.DOCUMENTS", "showQrLink", e.target.checked)
                            }
                            name="checkedA"
                        />
                    }
                    label="Show QR Code Link"
                />
                <br />
            </Menu>
            <Menu
                id="simple-menu-notes"
                anchorEl={menuOpen?.Notes ?? null}
                open={Boolean(menuOpen?.Notes ?? false)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={(event) => handleMenuClose(event, "Notes")}
            >
                <FormControlLabel
                    style={{
                        marginLeft: "5px",
                        paddingLeft: "10px",
                    }}
                    control={
                        <Button
                            variant="contained"
                            onClick={() => {
                                setNotes(defaultJobNotes);
                                props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "Notes", defaultJobNotes);
                            }}
                        >
                            Use Default Text
                        </Button>
                    }
                />
                <br />
            </Menu>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Edit Details</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Update this quote's buisness details. Note: This will not change your default buisness details.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label={"Display Name"}
                        value={buisnessDetails.name}
                        onChange={(e) => {
                            setBuisnessDetails({ ...buisnessDetails, name: e.target.value });
                        }}
                        onBlur={(e) => {
                            var user = props.job.User;
                            user.DisplayName = e.target.value;
                            props.updateUser(user);
                        }}
                        type="text"
                        fullWidth
                        variant="standard"
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label={"Address"}
                        value={buisnessDetails.address}
                        onChange={(e) => {
                            setBuisnessDetails({
                                ...buisnessDetails,
                                address: e.target.value,
                            });
                        }}
                        disabled={true}
                        type="text"
                        fullWidth
                        variant="standard"
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label={"ABN"}
                        disabled={true}
                        value={buisnessDetails.abn}
                        onChange={(e) => {
                            setBuisnessDetails({ ...buisnessDetails, abn: e.target.value });
                        }}
                        type="email"
                        fullWidth
                        variant="standard"
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label={"Distributor Email"}
                        value={buisnessDetails.email}
                        onChange={(e) => {
                            setBuisnessDetails({ ...buisnessDetails, email: e.target.value });
                        }}
                        onBlur={(e) => {
                            var distributor = props.job.Distributor;
                            distributor.Email = e.target.value;
                            props.updateDistributor(distributor);
                        }}
                        type="text"
                        fullWidth
                        variant="standard"
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label={"Distributor Phone"}
                        value={buisnessDetails.phone}
                        onChange={(e) => {
                            setBuisnessDetails({ ...buisnessDetails, phone: e.target.value });
                        }}
                        onBlur={(e) => {
                            var distributor = props.job.Distributor;
                            distributor.Phone = e.target.value;
                            props.updateDistributor(distributor);
                        }}
                        type="text"
                        fullWidth
                        variant="standard"
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label={"Building Licence"}
                        value={buisnessDetails.licence}
                        disabled={true}
                        onChange={(e) => {
                            setBuisnessDetails({
                                ...buisnessDetails,
                                licence: e.target.value,
                            });
                        }}
                        type="text"
                        fullWidth
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

// Hardcoded mappings are currently the only way to link these codes with their
// descriptions from the front-end
export function GetOutputName(name) {
    if (!name) return;

    const nameMap = {
        SB10865: "Cen Swage Box Beam 108 X 65 X 0.95BMT Colorbond",
        SB15865: "Cen Swage Box Beam 158 X 65 X 0.95BMT Colorbond",
        SB20865: "Cen Swage Box Beam 208 X 65 X 0.95BMT Colorbond",
        656510: "Cen Box Beam 65x65x0.95BMT Colorbond",
        1086510: "Cen Box Beam 108x65x0.95BMT Colorbond",
        1586510: "Cen Box Beam 158x65x0.95BMT Colorbond",
        2086510: "Cen Box Beam 208x65x0.95BMT Colorbond",
        FL15015: "150mm x 50mm Firmlok",
        FL20020: "200mm x 50mm Firmlok",
        FL10011: "100mm x 50mm Firmlok",
        FL10011M225: "100mm x 50mm Firmlok",
        FL15015M225: "150mm x 50mm Firmlok",
        FL20020M225: "200mm x 50mm Firmlok",
        CONCRETE_IN: "Concrete In",
        BOLT_TO_SLAB: "Bolt to Slab",
        HEAVY_FOOTING_BRACKET: "Heavy Footing Bracket",
    };

    // Return mapped name or handle custom replacements if not found
    if (nameMap[name]) {
        return nameMap[name];
    }

    // Handle replacement patterns if in_name isn't directly mapped
    return name.replace("C/Bond", "Colorbond").replace("D/S", "Double Sided");
}

function GetSizeSummary(areas) {
    var summary = "";
    for (let index in areas) {
        let area = areas[index];

        let overhangLeftRight =
            (area.SHAPE.OH_Left || 0) +
            (area.SHAPE.OH_Left_Sheet || 0) +
            (area.SHAPE.OH_Right || 0) +
            (area.SHAPE.OH_Right_Sheet || 0);

        let overhangFrontBack =
            (area.SHAPE.OH_Front || 0) +
            (area.SHAPE.OH_Front_Sheet || 0) +
            (area.SHAPE.OH_Back || 0) +
            (area.SHAPE.OH_Back_Sheet || 0);

        if (area?.META?.FrontState) {
            overhangFrontBack = area.META?.FrontState.ActualSheetOverhang + area.META.BackState.ActualSheetOverhang;
        }
        if (area?.META?.LeftState) {
            overhangLeftRight = area.META?.LeftState.ActualSheetOverhang + area.META?.RightState.ActualSheetOverhang;
        }

        summary +=
            (summary == "" ? "" : "; ") +
            "Area " +
            (Number(index) + 1) +
            ": " +
            (area.SHAPE.ActualStructureLength
                ? area.SHAPE.ActualStructureLength + overhangLeftRight
                : area.SHAPE.Length + overhangLeftRight) +
            "mm x " +
            (area.SHAPE.ActualStructureWidth
                ? area.SHAPE.ActualStructureWidth + overhangFrontBack
                : area.SHAPE.Depth + overhangFrontBack) +
            "mm";
    }
    return summary;
}

function ConvertListToString(array) {
    let outStr = "";
    for (var i = 0; i < array.length; i++) {
        outStr += array[i];
        if (i == array.length - 2) {
            outStr += " & ";
        } else if (i < array.length - 1) {
            outStr += ", ";
        }
    }
    return outStr;
}

function GetHeights(areas) {
    let heights = [];
    for (let area of areas) {
        if (!heights.includes(area.SHAPE.Height)) heights.push(area.SHAPE.Height);
    }
    return ConvertListToString(heights);
}

function GetRoofingSummary(areas) {
    let pitches = {};
    if (areas.length === 0) return "";
    if (areas.length === 1)
        return GetOutputName(
            areas[0].ROOF_SHEETING.RoofSheetData && areas[0].ROOF_SHEETING.RoofSheetData.roofsheet_display_name
                ? areas[0].ROOF_SHEETING.RoofSheetData.roofsheet_display_name
                : areas[0].ROOF_SHEETING.RoofType
        );
    let types = [];
    for (var area of areas) {
        let RoofSheetDescClean = GetOutputName(
            area.ROOF_SHEETING.RoofSheetData && area.ROOF_SHEETING.RoofSheetData.roofsheet_display_name
                ? area.ROOF_SHEETING.RoofSheetData.roofsheet_display_name
                : area.ROOF_SHEETING.RoofType
        );
        if (!types.includes(RoofSheetDescClean)) types.push(RoofSheetDescClean);

        if (area.SHAPE.DesignType === "Flat Roof") {
            if (!pitches["Flat"]) {
                pitches["Flat"] = [];
                pitches["Flat"].push(RoofSheetDescClean);
            } else {
                if (!pitches["Flat"].includes(RoofSheetDescClean)) pitches["Flat"].push(RoofSheetDescClean);
            }
        } else if (area.SHAPE.DesignType === "Gable") {
            if (pitches["Gable"] == null) {
                pitches["Gable"] = [];
                pitches["Gable"].push(RoofSheetDescClean);
            } else {
                if (!pitches["Gable"].includes(RoofSheetDescClean)) pitches["Gable"].push(RoofSheetDescClean);
            }
        } else if (area.SHAPE.DesignType === "Gable Hip Roof") {
            if (pitches["Portal"] == null) {
                pitches["Portal"] = [];
                pitches["Portal"].push(RoofSheetDescClean);
            } else {
                if (!pitches["Portal"].includes(RoofSheetDescClean)) pitches["Portal"].push(RoofSheetDescClean);
            }
        }
    }

    if (types.length == 1) return types[0];

    let output = [];
    if (pitches["Flat"]) {
        output.push(ConvertListToString(pitches["Flat"]) + " Flat");
    }
    if (pitches["Gable"]) {
        output.push(ConvertListToString(pitches["Gable"]) + " Pitched");
    }
    if (pitches["Portal"]) {
        output.push(ConvertListToString(pitches["Portal"]) + " Gable");
    }
    return ConvertListToString(output);
}

function GetPitchSummary(areas) {
    let pitches = {};
    if (areas.length === 0) return "";
    if (areas.length === 1) return GetOutputName(areas[0].SHAPE.RoofPitch + "º");
    for (var area of areas) {
        if (area.SHAPE.DesignType === "Flat Roof") {
            if (!pitches["Flat"]) {
                pitches["Flat"] = [];
                pitches["Flat"].push(area.SHAPE.RoofPitch + "º");
            } else {
                if (!pitches["Flat"].includes(area.SHAPE.RoofPitch + "º"))
                    pitches["Flat"].push(area.SHAPE.RoofPitch + "º");
            }
        } else if (area.SHAPE.DesignType === "Gable") {
            if (pitches["Gable"] == null) {
                pitches["Gable"] = [];
                pitches["Gable"].push(area.SHAPE.RoofPitch + "º");
            } else {
                if (!pitches["Gable"].includes(area.SHAPE.RoofPitch + "º"))
                    pitches["Gable"].push(area.SHAPE.RoofPitch + "º");
            }
        } else if (area.SHAPE.DesignType === "Gable Hip Roof") {
            if (pitches["Portal"] == null) {
                pitches["Portal"] = [];
                pitches["Portal"].push(area.SHAPE.RoofPitch + "º");
            } else {
                if (!pitches["Portal"].includes(area.SHAPE.RoofPitch + "º"))
                    pitches["Portal"].push(area.SHAPE.RoofPitch + "º");
            }
        }
    }

    let output = [];
    if (pitches["Flat"]) {
        output.push(ConvertListToString(pitches["Flat"]) + " Flat");
    }
    if (pitches["Gable"]) {
        output.push(ConvertListToString(pitches["Gable"]) + " Pitched");
    }
    if (pitches["Portal"]) {
        output.push(ConvertListToString(pitches["Portal"]) + " Gable");
    }
    return ConvertListToString(output);
}

export function getBeamDetails(beamType, area) {
    // Each const requires multiple fallbacks as report gen and design cloud use different variable names
    // for the same data
    const beamsAndPosts = area?.BEAMS_AND_POSTS;
    const designType = area?.SHAPE?.DesignType || area?.DesignType || "";
    const beamColKeyShort = `BeamCol${beamType}`;
    const beamColKeyLong = `BeamColour${beamType}`;
    const beamTypeKey = `BeamType${beamType}`;
    const roofType1 = area?.SHAPE?.RoofType1 || area?.RoofType1 || "";
    const roofType2 = area?.SHAPE?.RoofType2 || area?.RoofType2 || "";
    const colour =
        beamsAndPosts?.[beamColKeyShort] ||
        beamsAndPosts?.[beamColKeyLong] ||
        area?.[beamColKeyShort] ||
        area?.[beamColKeyLong] ||
        "TBA";
    const hasPurlin = (beamsAndPosts?.CountsFromEngineering?.EngNumPurlins || area?.EngNumPurlins) > 0;
    const hasRafter = (beamsAndPosts?.CountsFromEngineering?.EngNumRafters || area?.EngNumRafters) > 0;
    const isGableOnly = designType === "Gable Hip Roof" && roofType1 === "Gable" && roofType2 === "Gable";
    const type = GetOutputName(beamsAndPosts?.[beamTypeKey] || area?.[beamTypeKey] || null);

    const beamNames = {
        "Flat Roof": {
            1: "Fascia",
            ...(hasPurlin && { 2: "Purlin" }),
            ...(hasRafter && { 3: "Rafter" }),
        },
        "Pitched Roof": {
            1: "Rafter",
            3: "Fascia",
            4: "Pitching Beam",
            ...(hasPurlin && { 2: "Purlin" }),
        },
        "Gable Hip Roof": {
            1: "Rafter",
            3: "Edge Beam",
            ...(!isGableOnly && { 4: "Hip Beam" }),
            ...(hasPurlin && { 2: "Purlin" }),
        },
        "Flat Deck": {
            1: "Bearer",
            2: "Joist",
        },
    };

    const name = beamNames[designType]?.[beamType] || null;

    if (name === null || type === null) {
        return null;
    }

    return { name, type, colour };
}

export function GetNumberofSkylightsSummary(areas) {
    let syklights = 0;
    let types = [];
    for (var area of areas) {
        if (area.SKYLIGHTS.length > 0) {
            syklights += area.SKYLIGHTS.length;
            let type = "Polycarbonate";
            let skylight_type = area?.ROOF_SHEETING?.SkylightType;
            if (skylight_type) {
                if (Contains(skylight_type.toUpperCase(), "SOLARSPAN", "VERSICLAD", "INSULROOF", "APOLLO")) {
                    type = "Insulated Panel";
                } else if (Contains(skylight_type.toUpperCase(), "ALSYNITE")) {
                    type = "Alsynite";
                }
            }
            if (!types.includes(type)) types.push(type);
        }
    }
    if (syklights === 0) return null;
    return syklights + " " + ConvertListToString(types) + " Skylight sheets.";
}

export function GetNumberofSkylightsSummaryArea(area) {
    if (area.SKYLIGHTS.length > 0) return true;
    return false;
}

function Contains(value, values_to_check) {
    if (typeof values_to_check === "string") {
        return value.includes(values_to_check);
    }
    if (Array.isArray(values_to_check)) {
        for (let val of values_to_check) {
            if (value.includes(val)) return true;
        }
    }
    return false;
}

function GetGutterTypes(areas) {
    let types = [];
    for (var area of areas) {
        let type = area.GUTTERS_AND_DOWNPIPES.GutterType;
        let colour =
            area.GUTTERS_AND_DOWNPIPES.GutterCol === "Zincalume" ? area.GUTTERS_AND_DOWNPIPES.GutterCol : "Colorbond";
        let combined = colour + " " + type;

        if (!types.includes(combined)) {
            types.push(combined);
        }
    }
    return ConvertListToString(types);
}

function GetDownpipeTypes(areas) {
    let types = [];
    for (var area of areas) {
        let dp_str = area.GUTTERS_AND_DOWNPIPES.DownpipeType;
        if (!dp_str.includes("PVC")) dp_str = dp_str.replace("Downpipe", "Colorbond Downpipe");
        if (!types.includes(dp_str)) types.push(dp_str);
    }
    return ConvertListToString(types);
}

function GetGableEndInfills(areas, back_side = false) {
    let types = [];
    for (var area of areas) {
        if (area.SHAPE.DesignType === "Gable" || area.SHAPE.DesignType === "Gable Hip Roof") {
            let infill = back_side ? area.GABLE_PARAMETERS.TrussInfill2 : area.GABLE_PARAMETERS.TrussInfill1;
            if (!types.includes(infill)) types.push(infill);
        }
    }
    return ConvertListToString(types);
}

function GetPortalFrames(areas) {
    let types = [];
    for (var area of areas) {
        if (area.SHAPE.DesignType === "Gable Hip Roof") {
            if (!types.includes(GetOutputName(area.BEAMS_AND_POSTS.PostType)))
                types.push(GetOutputName(area.BEAMS_AND_POSTS.PostType));
        }
    }
    return ConvertListToString(types);
}
function GetPosts(areas) {
    let types = [];
    for (var area of areas) {
        if (!types.includes(GetOutputName(area.BEAMS_AND_POSTS.PostType)))
            types.push(GetOutputName(area.BEAMS_AND_POSTS.PostType));
    }
    return ConvertListToString(types);
}

function HasBoxGutters(areas) {
    for (var area of areas) {
        {
            if (
                area.GUTTERS_AND_DOWNPIPES.GutterF == 2 ||
                area.GUTTERS_AND_DOWNPIPES.GutterB == 2 ||
                area.GUTTERS_AND_DOWNPIPES.GutterL == 2 ||
                area.GUTTERS_AND_DOWNPIPES.GutterR == 2
            )
                return true;
        }
        return false;
    }
}

function GetHasDownlightFlashing(areas) {
    for (var area of areas) {
        {
            if (area.SHAPE.DesignType === "Gable" || area.SHAPE.DesignType === "Gable Hip Roof") {
                if (isTrue(area.GABLE_PARAMETERS.DownlightFlashing)) return true;
            }
        }
        return false;
    }
}

export function GetAreaDescription(area, withPitch = false) {
    let areaDescription = "";
    const designType = area?.SHAPE?.DesignType;

    if (designType === "Flat Deck") {
        return "Deck";
    }
    if (designType === "Louvre Roof") {
        return "Louvreroof";
    }

    if (designType === "Flat Roof") {
        if (area?.SHAPE?.DesignTemplateType === "National Carport") {
            return "National Carport";
        }

        if (area.Mode == "Galv") {
            areaDescription = "Galvanised Flat Roof";
        } else {
            areaDescription = "Flat Verandah";
        }
    } else if (designType === "Gable Roof" || designType === "Pitched Roof") {
        areaDescription = "Pitched Verandah";
    } else if (designType === "Gable Hip Roof") {
        const RoofType1 = area.SHAPE.RoofType1;
        const RoofType2 = area.SHAPE.RoofType2;

        if (RoofType1 === RoofType2 && RoofType1 === "Gable") {
            areaDescription = "Portal Gable";
        } else if (RoofType1 === RoofType2) {
            areaDescription = RoofType1 + " Portal Gable";
        } else if (RoofType2 === "Gable") {
            areaDescription = "Single " + RoofType1 + " Portal Gable";
        } else if (RoofType1 === "Gable") {
            areaDescription = "Single " + RoofType2 + " Portal Gable";
        } else {
            areaDescription += "Portal Gable Mixed End Types";
        }

        if (area.BEAMS_AND_POSTS.PortalPostType === 1) {
            areaDescription = areaDescription.replace("Portal Gable", "Gable");

            if (!isTrue(area.BEAMS_AND_POSTS.HasRidgeBeam)) {
                areaDescription += " (Purlins On Top)";
            }
        } else {
            if (isTrue(area.BEAMS_AND_POSTS.HasRidgeBeam)) {
                areaDescription += " (Inset Purlins)";
            }
        }
    }

    if (withPitch) areaDescription += " (" + area.SHAPE.RoofPitch + "º" + ")";

    return areaDescription;
}

export function GetDesignStringShort(areas) {
    if (areas.length === 1) return GetAreaDescription(areas[0]);
    let areas_types = [];
    for (let area of areas) {
        let this_desc = GetAreaDescription(area);

        if (this_desc) {
            if (!areas_types.includes(this_desc)) areas_types.push(this_desc);
        }
    }
    if (areas_types.length === 1) {
        if (areas.length > 1) return areas_types[0] + " Combination";
    }
    if (areas_types.length > 1) {
        let out_str = "";
        for (var i = 0; i < areas_types.length - 1; i++) {
            if (out_str != "") out_str += ", ";
            out_str += areas_types[i].replace(" Verandah", "");
        }
        out_str += " and " + areas_types[areas_types.length - 1] + " Combination";
        return out_str;
    }
    return "None";
}

export function GenerateSummaryRaw(job) {
    if (!job) return null;

    const list_of_supply_and_install_items = {};
    const DeckMode = job.DesignParameters.DeckMode === 1;
    const LouvreMode = job.DesignParameters.LouvreMode === 1;

    list_of_supply_and_install_items["Size"] = GetSizeSummary(job.AreaSpecifications);
    list_of_supply_and_install_items["Height"] = GetHeights(job.AreaSpecifications) + " mm";

    if (LouvreMode) {
        list_of_supply_and_install_items["Roofing Material"] = GetRoofingSummary(job.AreaSpecifications);

        const skylight_summary = GetNumberofSkylightsSummary(job.AreaSpecifications);
        if (skylight_summary) list_of_supply_and_install_items["Skylights"] = skylight_summary;
    } else if (DeckMode) {
        const bearer_colour = job.AreaSpecifications[0]?.BEAMS_AND_POSTS.BeamCol1.toUpperCase().includes("GALV")
            ? "Galvanised "
            : "";
        list_of_supply_and_install_items["Bearers"] = `${bearer_colour}${GetOutputName(
            job.AreaSpecifications[0]?.BEAMS_AND_POSTS.BeamType1
        )}`;

        const joist_colour = job.AreaSpecifications[0]?.BEAMS_AND_POSTS.BeamCol2.toUpperCase().includes("GALV")
            ? "Galvanised "
            : "";
        list_of_supply_and_install_items["Joists"] = `${joist_colour}${GetOutputName(
            job.AreaSpecifications[0]?.BEAMS_AND_POSTS.BeamType2
        )}`;

        const post_colour = job.AreaSpecifications[0]?.BEAMS_AND_POSTS.PostCol.toUpperCase().includes("GALV")
            ? "Galvanised "
            : "";
        list_of_supply_and_install_items["Posts"] = `${post_colour}${GetPosts(job.AreaSpecifications)} Posts`;
    } else {
        list_of_supply_and_install_items["Roofing Material"] =
            GetRoofingSummary(job.AreaSpecifications) + " Roof Sheeting";

        const skylight_summary = GetNumberofSkylightsSummary(job.AreaSpecifications);
        if (skylight_summary) list_of_supply_and_install_items["Skylights"] = skylight_summary;

        list_of_supply_and_install_items["Gutters"] = GetGutterTypes(job.AreaSpecifications);

        if (HasBoxGutters(job.AreaSpecifications)) {
            list_of_supply_and_install_items["Box Gutter"] = "Colorbond box gutters where indicated.";
        }

        list_of_supply_and_install_items["Downpipes"] = GetDownpipeTypes(job.AreaSpecifications);

        const infills_front = GetGableEndInfills(job.AreaSpecifications);
        const infills_back = GetGableEndInfills(job.AreaSpecifications, true);

        if (infills_front && infills_front === infills_back) {
            list_of_supply_and_install_items["Infills"] = `${infills_front} to gable ends`;
        } else {
            if (infills_front) list_of_supply_and_install_items["Front Infills"] = `${infills_front} gable end`;
            if (infills_back) list_of_supply_and_install_items["Rear Infills"] = `${infills_back} gable end`;
        }

        const portal_frames = GetPortalFrames(job.AreaSpecifications);
        list_of_supply_and_install_items["Post"] = portal_frames
            ? `${portal_frames} Posts and Portal Frames`
            : `${GetPosts(job.AreaSpecifications)} Posts`;

        const groupedBeamDetails = {};
        for (let area of job.AreaSpecifications) {
            for (let i = 1; i <= 4; i++) {
                let beamDetails = getBeamDetails(i, area);
                if (beamDetails) {
                    const { name, type } = beamDetails;
                    if (groupedBeamDetails[name]) {
                        let types = groupedBeamDetails[name].split(", ");
                        if (!types.includes(type)) {
                            groupedBeamDetails[name] += `, ${type}`;
                        }
                    } else {
                        groupedBeamDetails[name] = type;
                    }
                }
            }
        }

        for (let name in groupedBeamDetails) {
            if (groupedBeamDetails.hasOwnProperty(name)) {
                list_of_supply_and_install_items[name] = groupedBeamDetails[name];
            }
        }

        if (GetHasDownlightFlashing(job.AreaSpecifications))
            list_of_supply_and_install_items["Downlight Flashing"] = "Matching Colorbond central down light housing";
    }

    return list_of_supply_and_install_items;
}

export function GenerateSummary(job) {
    var list_of_supply_and_install_items = GenerateSummaryRaw(job);
    let summary_list = [];

    for (let key in list_of_supply_and_install_items) {
        summary_list.push(
            <div key={key}>
                <span style={{ color: "rgb(0,52,102)" }}>
                    <strong>{key}: </strong>
                </span>
                {list_of_supply_and_install_items[key]}
            </div>
        );
    }
    return summary_list;
}

// COMMMON FUNCTIONS
export function isTrue(value, value2 = null, value3 = null) {
    let val = isThisTrue(value);
    let val2 = isThisTrue(value2);
    let val3 = isThisTrue(value3);
    return val | val2 | val3;
}

export function isThisTrue(value) {
    if (value === undefined) return false;
    if (value === null) return false;
    if (typeof value === "string") {
        if (value === "1") return true;
        if (value.toUpperCase() === "TRUE") return true;
    }
    if (value === 1) return true;
    if (value === true) return true;
    return false;
}

export function toNumber(value, allow_negative = true, allow_decimal = true) {
    if (typeof value === "number") return value;
    if (!value) return 0;
    if (value.replace) {
        let neg = false;
        if (allow_negative && value.startsWith("-")) neg = true;
        let str = value.replace(/[^0-9.]/g, "").split(".");
        let form_str = (neg ? "-" : "") + str[0] + (allow_decimal && str.length > 1 ? "." + str[1] : "");
        return Number(form_str);
    }
    return Number(value);
}
